import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Scene } from '../../../../../model/scene';
import { VideoPlayerComponent, VideoPlayerEvents, VideoPlayerSubscriber } from '../../../video-player.component';

@Component({
  selector: 'app-scene-card',
  templateUrl: './scene-card.component.html',
  styleUrls: ['./scene-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class SceneCardComponent implements OnInit, VideoPlayerSubscriber {

  @Input() videoPlayer: VideoPlayerComponent;
  @Input() scene: Scene;
  @Input() isLooping: boolean = false;

  @Output() onSceneSelected: EventEmitter<Scene> = new EventEmitter<Scene>();

  @ViewChild('nativeHtmlCard', { read: ElementRef }) nativeHtmlCard: ElementRef;

  isSelected: boolean = false;

  isImageDownloaded: boolean = false;

  constructor() { }

  ngOnInit() {
    this.videoPlayer.subscribeToVideoEvents(this);
    this.checkIfSceneIsSelected();
  }

  notify(event: VideoPlayerEvents): void {
    if (event === VideoPlayerEvents.SEEK) {
      this.checkIfSceneIsSelected();
    }
  }

  secondsToTime(seconds: number): string {
    let hours: number = 0;
    let minutes: number = 0;
    let secs: number = 0;

    minutes = Math.floor(seconds / 60);
    secs = Math.floor(seconds % 60);

    hours = Math.floor(minutes / 60);
    minutes = Math.floor(minutes % 60);

    const hoursStr: string = (hours < 10) ? `0${hours}` : `${hours}`;
    const minutesStr: string = (minutes < 10) ? `0${minutes}` : `${minutes}`;
    const secondsStr: string = (secs < 10) ? `0${secs}` : `${secs}`;

    let time: string = `${minutesStr}:${secondsStr}`;

    if (hours > 0) {
      time = `${hoursStr}:${time}`;
    }

    return time
  }

  sceneSelected() {

    if (!this.videoPlayer || !this.scene) {
      return;
    }
    this.videoPlayer.seekVideoTo(this.scene.start_time_in_seconds);
  }

  protected onImageDownloaded() {
    this.isImageDownloaded = true;
  }

  private checkIfSceneIsSelected() {

    if (!this.videoPlayer || !this.scene) {
      return;
    }

    const previousStateOfIsSelected = this.isSelected;
    const currentTime = this.videoPlayer.getCurrentTime();
    this.isSelected = currentTime >= this.scene.start_time_in_seconds &&
      currentTime < this.scene.end_time_in_seconds;

    if (this.isSelected && !previousStateOfIsSelected) {
      this.onSceneSelected.emit(this.scene);
      this.scrollIntoView();
    }

  }

  private scrollIntoView() {
    this.nativeHtmlCard?.nativeElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'end'
    });

  }

}
